import { LitElement, html } from 'lit';

class InventoryView extends LitElement {
  createRenderRoot() { return this; }

  render() {
    return html`
      <div class="max-w-7xl mx-auto px-4 py-6 md:ml-64">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Kitchen Inventory</h1>
        <div class="bg-white rounded-lg shadow p-12 text-center">
          <p class="text-gray-500">Coming soon</p>
        </div>
      </div>
    `;
  }
}

customElements.define('inventory-view', InventoryView);
